import { render, staticRenderFns } from "./StudentCalendar.vue?vue&type=template&id=074fbe9c&"
import script from "./StudentCalendar.vue?vue&type=script&lang=js&"
export * from "./StudentCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('074fbe9c')) {
      api.createRecord('074fbe9c', component.options)
    } else {
      api.reload('074fbe9c', component.options)
    }
    module.hot.accept("./StudentCalendar.vue?vue&type=template&id=074fbe9c&", function () {
      api.rerender('074fbe9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/StudentCalendar/StudentCalendar.vue"
export default component.exports